module.exports = __webpack_public_path__ + "img/chanpindefen.568eaaea.svg";